import { getMediaSrc, ImageSizeSet } from '@internal/utils/media/getMediaSrc';
import { ignoreColumnCtaClickClass } from '@renderer-ui-library/mui/base/constants';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/splide/dist/css/splide.min.css';
import classNames from 'classnames';
import React from 'react';

import { CmsMediaFile } from '@internal/utils/media/Media';
import styles from './imageSlider.module.scss';

export type ImageSliderProps = {
    images: CmsMediaFile[];
    ratio: number | 'original'; // width / height
    autoPlay?: boolean;
    pagination: boolean;
    arrows: boolean;
    sizeSet?: ImageSizeSet;
};

export const ImageSlider: React.FC<ImageSliderProps> = React.memo(
    ({ images, ratio, autoPlay, pagination, arrows, sizeSet }) => (
        <Splide
            options={{
                width: '100%',
                heightRatio: typeof ratio === 'number' ? 1 / ratio : undefined,
                rewind: true,
                autoplay: autoPlay,
                pagination: pagination,
                arrows: arrows,
                interval: 3500,
                speed: autoPlay ? 1000 : 400,
                easing: 'ease',
                classes: {
                    arrows: `splide__arrows ${ignoreColumnCtaClickClass}`,
                    pagination: `splide__pagination ${ignoreColumnCtaClickClass}`,
                },
            }}
            className={classNames(styles.slider, {
                [styles.cover]: !ratio,
            })}
        >
            {images.map((image, index) => {
                const mediaSource = getMediaSrc(image, { ratio, sizeSet });
                return (
                    <SplideSlide key={`${index}-${image.attributes.url}`}>
                        <img
                            loading="lazy"
                            className={styles.image}
                            alt={image.attributes.alternativeText ?? ''}
                            {...mediaSource}
                        />
                    </SplideSlide>
                );
            })}
        </Splide>
    ),
);

ImageSlider.displayName = 'ImageSlider';
